import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class EnableSolutionsLinkGuard implements CanActivate {
  constructor(private router: Router) {}

  async canActivate() {
    if (environment.enableSolutionsLink === false) {
      this.router.navigate(['/']);
    }
    return true;
  }
}
